import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import type { GroupStatisticsItem } from '../../types/reports';
import AccessibleChartSummary from './AccessibleChartSummary';

const COLORS = ['#2563EB', '#7C3AED', '#EA580C'];

export default function GroupStatisticsChart({ data }: { data: GroupStatisticsItem[] }) {
  const totalGroups = data.reduce((total, item) => total + item.count, 0);

  return (
    <>
      <ResponsiveContainer width="100%" height={270}>
        <PieChart>
          <Pie data={data} dataKey="count" nameKey="groupType" outerRadius={110} label={false}>
            {data.map((item, index) => (
              <Cell key={item.groupType} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => [`${value} groups`, 'Count']} />
        </PieChart>
      </ResponsiveContainer>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2" aria-label={`Group statistics legend. ${totalGroups} groups total.`}>
        {data.map((item, index) => (
          <div key={item.groupType} className="flex min-w-0 items-center justify-between gap-3 rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 text-sm">
            <span className="flex min-w-0 items-center gap-2 font-medium text-slate-700">
              <span
                className="h-2.5 w-2.5 shrink-0 rounded-full"
                style={{ backgroundColor: COLORS[index % COLORS.length] }}
                aria-hidden="true"
              />
              <span className="truncate">{item.groupType}</span>
            </span>
            <span className="shrink-0 font-semibold text-slate-900">{item.count}</span>
          </div>
        ))}
      </div>
      <AccessibleChartSummary caption="Group statistics" categoryHeader="Group type" valueHeader="Groups" rows={data.map((item) => ({ label: item.groupType, value: item.count }))} />
    </>
  );
}
